import { render, staticRenderFns } from "./RiskCalculator.vue?vue&type=template&id=95ba6be0&scoped=true"
import script from "./RiskCalculator.vue?vue&type=script&lang=js"
export * from "./RiskCalculator.vue?vue&type=script&lang=js"
import style0 from "./RiskCalculator.vue?vue&type=style&index=0&id=95ba6be0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95ba6be0",
  null
  
)

export default component.exports